
(window as any).ElementPropertiesBase=require('./ElementPropertiesBase').ElementPropertiesBase;
(window as any).DatePickerProperty=require('./DatePickerProperty').DatePickerProperty;
(window as any).SimpleTextProperty=require('./SimpleTextProperty').SimpleTextProperty;
(window as any).RedNaoIconSelector=require('./RedNaoIconSelector').RedNaoIconSelector;
(window as any).SimpleNumericProperty=require('./SimpleNumericProperty').SimpleNumericProperty;
(window as any).CheckBoxProperty=require('./CheckBoxProperty').CheckBoxProperty;
(window as any).ArrayProperty=require('./ArrayProperty').ArrayProperty;
(window as any).IdProperty=require('./IdProperty').IdProperty;
(window as any).ComboBoxProperty=require('./ComboBoxProperty').ComboBoxProperty;
(window as any).IconProperty=require('./IconProperty').IconProperty;
(window as any).CustomCSSProperty=require('./CustomCSSProperty').CustomCSSProperty;
(window as any).PropertyContainer=require('./PropertyContainer').PropertyContainer;
(window as any).TimePickerProperty=require('./TimePickerProperty').TimePickerProperty;
